export const fieldTranslations = {
  name: "Name",
  short_name: "Short Name",
  demo_alias_name: "Demo Alias",
  currency_text: "Currency",
  company: "Company",
  issuer: "Issuer",
  risk_free_benchmark: "Risk Free Benchmark",
  benchmark: "Benchmark",
  // codes'
  isin: "ISIN",
  ticker: "Ticker",
  reuters_ticker: "Reuters Ticker",
  yahoo_ticker: "Yahoo Ticker",
  code: "Code",
  provider_compo_code: "Provider Compo Code",
  provider_fixings_code: "Provider Fixings Code",

  // Internal Fields
  status: "Status",
  type: "Type",
  priority: "Priority",
  user: "User",
  calculation_agent: "Calculation Agent",
  administrator: "Administrator",
  provider_url: "Provider URL",
  source_url: "Source URL",
  open_figi_id: "Open FIGI ID",
  // Fund Fields
  fund_name: "Fund Name",
  fund_currency: "Fund Currency",
  etf_leverage_factor: "ETF Leverage Factor",
  financial_period_end: "Financial Period End",
  share_class: "Share Class",
  // Derivative Fields
  derivative_underlying_name: "Underlying Name",
  derivative_underlying_code: "Underlying Code",
  // Static Data
  maturity: "Maturity",
  live_date: "Live Date",
  coupon: "Coupon",
  tranche: "Tranche",
  publication_delay: "Publication Delay",
  frequency: "Frequency",
  instrument: "Instrument",
  alpha_beta: "Alpha/Beta",
  asset_class: "Asset Class",
  risk_factor: "Risk Factor",
  bond_type: "Bond Type",
  counterparty_issuer_id: "Counterparty Issuer ID",
  derivative_type: "Derivative Type",
  derivative_strike: "Derivative Strike",
  aum_fund_level_currency: "AUM Fund Level Currency",
  aum_share_class_currency: "AUM Share Class Currency",
  contract_size: "Contract Size",
  return_type: "Return Type",
  description: "Description",
  country_of_registration: "Country of Registration",
  // Ratings
  rating: "Rating",
  barcap_rating: "Barcap Rating",
  citi_rating: "Citi Rating",
  moodys_rating: "Moody's Rating",
  sp_rating: "S&P Rating",
  bloomberg_rating: "Bloomberg Rating",
  //Composition Static Data
  compo_publication_delay: "Compo Publication Delay",
  compo_frequency: "Compo Frequency",
  replicated_strategy: "Replicated Strategy",
  derivative_underlying: "Derivative Underlying",
  is_hedged: "is Hedged",
  is_main_share_class: "Is Main Share Class",
  is_institutional_share_class: "Is Institutional Share Class",
  is_downloadable: "Is Downloadable",
  is_benchmark: "Is Benchmark",
  is_allowed_to_us: "Is Allowed to US",
  is_long_short: "Is Long Short",
  allow_past_fixings_data: "Allow Past Fixings Data",
};

export default fieldTranslations;
